import { BasketCouponPackageModel } from './basket-coupon-package.model';

export enum CouponType {
  GLOBAL= 'GLOBAL',
  PACKAGE= 'PACKAGE'
}

export enum DiscountTypeEnum {
  FIX = 'FIX',
  PERCENT = 'PERCENT'
}

export interface BasketCouponModel {
  code: string;
  created_at: string;
  discount: number;
  id: number;
  name: string;
  status: boolean;
  updated_at: string;
  valid_end: string;
  valid_from: string;
  coupon_type: CouponType;
  discount_type: DiscountTypeEnum;
  packages: BasketCouponPackageModel[];
}
